export default __webpack_public_path__ + "iddaa-logo.png";